import { render, staticRenderFns } from "./CallCard.vue?vue&type=template&id=120948c4&scoped=true&"
import script from "./CallCard.vue?vue&type=script&lang=js&"
export * from "./CallCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120948c4",
  null
  
)

export default component.exports